<!--
 * @Description: 著作权人信息（不可编辑详情页）
 * @Author: ll
 * @Date: 2021-9-9 14:30:30
 * @LastEditTime: 
 * @LastEditors: ll
-->
<template>
  <a-modal :visible="copyVisible" class="cr-copyInfo cr-fs-md" title="著作权人信息" @ok="handleOk" @cancel="cancel" width="900px">
    <!-- 企业单位 -->
    <div v-if="copyData.category === 1">
      <div class="cr-owner">
        <p class="cr-desc1">企业名称：</p>
        <p class="cr-desc2">{{ copyData.ownerName }}</p>
      </div>
      <div class="cr-owner">
        <p class="cr-desc1">社会信用代码：</p>
        <p class="cr-desc2">{{ copyData.socialCreditCode }}</p>
      </div>
      <div class="cr-owner">
        <p class="cr-desc1">公司成立日期：</p>
        <p class="cr-desc2">{{ copyData.companyFoundDate }}</p>
      </div>
      <div class="cr-owner">
        <p class="cr-desc1">证明文件：</p>
        <p class="cr-desc3"><img @click="openImg(copyData.certified)" :src="copyData.certified" /></p>
      </div>
      <div class="cr-owner" v-if="lt3Month">
        <p class="cr-desc1">前期开发说明：</p>
        <p class="cr-desc2">
          <!-- <span class="cr-mr-1" @click="downFile(copyData.developInstruction, '前期开发说明')">查看文件</span> -->
          <a :href="link6">下载模版</a>
        </p>
      </div>
      <div class="cr-owner" v-if="lt3Month">
        <p class="cr-desc1">技术员身份证明：</p>
        <div class="cr-flex cr-flex-wrap">
          <p class="cr-desc3" v-for="(copy, index) in copyData.technicianCertified" :key="index"><img @click="openImg(copy.url)" :src="copy.url" /></p>
        </div>
      </div>
    </div>
    <!-- 事业单位 -->
    <div v-if="copyData.category === 2">
      <div class="cr-owner">
        <p class="cr-desc1">企业名称：</p>
        <p class="cr-desc2">{{ copyData.ownerName }}</p>
      </div>
      <div class="cr-owner">
        <p class="cr-desc1">社会信用代码：</p>
        <p class="cr-desc2">{{ copyData.socialCreditCode }}</p>
      </div>
      <div class="cr-owner">
        <p class="cr-desc1">有效期：</p>
        <p class="cr-desc2">{{ copyData.validPeriodStart }} 至 {{ copyData.validPeriodEnd }}</p>
      </div>
      <div class="cr-owner">
        <p class="cr-desc1">证明文件：</p>
        <p class="cr-desc3 cr-mr-1"><img :src="copyData.certified" @click="openImg(copyData.certified)" /></p>
      </div>
    </div>
    <!-- 分公司 -->
    <div v-if="copyData.category === 3">
      <div class="cr-owner">
        <p class="cr-desc1">企业名称：</p>
        <p class="cr-desc2">{{ copyData.ownerName }}</p>
      </div>
      <div class="cr-owner">
        <p class="cr-desc1">社会信用代码：</p>
        <p class="cr-desc2">{{ copyData.socialCreditCode }}</p>
      </div>
      <div class="cr-owner">
        <p class="cr-desc1">公司成立日期：</p>
        <p class="cr-desc2">{{ copyData.companyFoundDate }}</p>
      </div>
      <div class="cr-owner">
        <p class="cr-desc1">分公司营业执照：</p>
        <p class="cr-desc3"><img :src="copyData.branchBusinessLicense" @click="openImg(copyData.branchBusinessLicense)" /></p>
      </div>
      <div class="cr-owner">
        <p class="cr-desc1">上级单位营业执照：</p>
        <p class="cr-desc3"><img :src="copyData.superiorBusinessLicense" @click="openImg(copyData.superiorBusinessLicense)" /></p>
      </div>
      <div class="cr-owner">
        <p class="cr-desc1">上级单位法人证明：</p>
        <p class="cr-desc3"><img :src="copyData.legalPersonsCretified" @click="openImg(copyData.legalPersonsCretified)" /></p>
      </div>
    </div>
    <!-- 自然人 -->
    <div v-if="copyData.category === 4">
      <div class="cr-owner">
        <p class="cr-desc1">个人姓名：</p>
        <p class="cr-desc2">{{ copyData.ownerName }}</p>
      </div>
      <div class="cr-owner">
        <p class="cr-desc1">身份证号码：</p>
        <p class="cr-desc2">{{ copyData.idCard }}</p>
      </div>
      <div class="cr-owner">
        <p class="cr-desc1">身份证明：</p>
        <p class="cr-desc3"><img :src="copyData.identityIdCardCertified" @click="openImg(copyData.identityIdCardCertified)" /></p>
      </div>
    </div>
    <!-- 未成年人 -->
    <div v-if="copyData.category === 5">
      <div class="cr-owner">
        <p class="cr-desc1">个人姓名：</p>
        <p class="cr-desc2">{{ copyData.ownerName }}</p>
      </div>
      <div class="cr-owner">
        <p class="cr-desc1">身份证号码：</p>
        <p class="cr-desc2">{{ copyData.idCard }}</p>
      </div>
      <div class="cr-owner">
        <p class="cr-desc1">身份证明：</p>
        <p class="cr-desc3"><img :src="copyData.identityIdCardCertified" @click="openImg(copyData.identityIdCardCertified)" /></p>
      </div>
      <div class="cr-owner">
        <p class="cr-desc1">监护人证明：</p>
        <p class="cr-desc3"><img :src="copyData.guardianSignCertified" @click="openImg(copyData.guardianSignCertified)" /></p>
      </div>
      <div class="cr-owner">
        <p class="cr-desc1">监护人证明：</p>
        <p class="cr-desc3"><img :src="copyData.guardianIdCardCretified" @click="openImg(copyData.guardianIdCardCretified)" /></p>
      </div>
      <div class="cr-owner">
        <p class="cr-desc1">户口证明：</p>
        <p class="cr-desc3 cr-mr-1" v-for="(copy, index) in copyData.hukouCertified" :key="index"><img :src="copy" @click="openImg(copy)" /></p>
      </div>
    </div>
    <div v-show="imgurl" class="showimg">
      <div class="zhezhao" />
      <img :src="imgurl" class="pic" />
      <div class="close" @click="closeimg">X</div>
    </div>
  </a-modal>
</template>

<script>
import { link6 } from './templateUrl'
import moment from 'moment'
export default {
  props: {
    copyVisible: Boolean,
    copyData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      lt3Month: false,
      link6, // 前期开发说明
      imgurl: ''
    }
  },
  watch: {
    // 计算成立时间是否超过三个月
    'copyData.companyFoundDate'(date) {
      if (date) {
        let currentDate = moment().format('YYYY-MM-DD') //当前时间
        const diff = moment(currentDate).diff(moment(date), 'months')
        diff < 3 ? (this.lt3Month = true) : (this.lt3Month = false)
      }
    }
  },
  methods: {
    closeimg() {
      this.imgurl = undefined
    },
    openImg(url) {
      this.imgurl = url
    },
    handleOk() {
      this.$emit('update:copyVisible', false)
    },
    cancel() {
      this.$emit('update:copyVisible', false)
    },
    downFile(url, title) {
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', title)
      document.body.appendChild(link)
    }
  }
}
</script>

<style lang="less" scoped>
.cr-copyInfo {
  .ant-modal-content {
    .ant-modal-body {
      .ant-form-item {
        display: flex;
      }
      .cr-owner {
        display: flex;
        align-items: center;
        margin-bottom: 35px;
        .cr-desc1 {
          color: #333;
          width: 120px;
          text-align: left;
          &::before {
            display: inline-block;
            content: '*';
            color: #ff4d4f;
            font-size: 14px;
            margin-right: 4px;
          }
        }
        .cr-desc2 {
          color: #666;
          span {
            color: #1664ff;
            text-decoration: underline;
            cursor: pointer;
          }
        }
        .cr-desc3 {
          width: 160px;
          height: 120px;
          margin-right: 10px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .showimg {
        .zhezhao {
          position: fixed;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background-color: #000;
          opacity: 0.7;
          z-index: 99;
        }
        .pic {
          position: fixed;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          z-index: 100;
          max-width: 1000px;
        }
        .close {
          position: fixed;
          top: 80px;
          right: 80px;
          width: 60px;
          height: 60px;
          background-color: #eee;
          border-radius: 50%;
          color: #666;
          font-size: 40px;
          text-align: center;
          line-height: 60px;
          z-index: 100;
          cursor: pointer;
          opacity: 0.7;
        }
      }
    }
  }
}
</style>
